/* eslint-disable */
import { Grid, makeStyles } from '@material-ui/core';
import React, { useState, useMemo, useCallback, useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import _, { isEmpty } from 'lodash';
import { v4 as uuid } from 'uuid';
import useDownloader from '../../utils/hooks/downloader/useDownloader';
import useValidators from '../../utils/hooks/useValidators';
import useModeParam from '../../utils/hooks/mode-param/useModeParam';
import { maxValue, required as requiredValidator, validateWeekDay } from '../../utils/validators/field/validator';
import QCXFormTitle from '../form-title/QCXFormTitle';
import { OPEN_STATUS, CLOSED_STATUS } from '../../utils/hooks/form/dialog/formDialogUtils';
import QCXDuplicateDespesaDialogForm from './QCXDuplicateDespesaDialogForm'; // ajuste o path
import QCXSolicitacaoPagamentoFinanceiroObservacoesGroup from './QCXSolicitacaoPagamentoFinanceiroObservacoesGroup';
import QCXFinalAlternativeCurrencyField from '../../shared-components/final-currency-field/QCXFinalAlternativeCurrencyField';
import QCXFinalDatePickerField from '../../shared-components/final-date-picker-field/QCXFinalDatePickerField';
import QCXFinalForm from '../../shared-components/final-form/QCXFinalForm';
import QCXSelectMoedaAutocomplete from '../../shared-components/final-select-moeda-field/QCXSelectMoedaAutocomplete';
import QCXSelectFornecedorAutocomplete from '../../shared-components/select-fornecedor-favorecido-autocomplete/QCXSelectFornecedorAutocomplete';
import QCXSelectFavorecidoAutocomplete from '../../shared-components/select-fornecedor-favorecido-autocomplete/QCXSelectFavorecidoAutocomplete';
import QCXSelectContaBancariaAutocompleteField from '../../shared-components/select-conta-bancaria/QCXSelectContaBancariaAutocompleteField';
import QCXSelectFormaPagamentoAutocompleteField from '../../shared-components/select-forma-pagamento/QCXSelectFormaPagamentoAutocompleteField';
import QCXFinalPercentualField from '../../shared-components/final-percentual-field/QCXFinalPercentualField';
import QCXFinalCheckboxField from '../../shared-components/final-checkbox-field/QCXFinalCheckboxField';
import QCXFinalPdfInputFile from '../../shared-components/input-file/QCXFinalPdfInputFile';
import QCXDataGrid from '../../shared-components/data-grid/QCXDataGrid';
import {
  getCurrentDate,
  isValid,
  isWeekend,
  normalizeNumeral,
  unnormalizeNumeral,
} from '../../utils/general/general-utils';
import QCXFinalDateTimePickerField from '../../shared-components/final-date-time-picker-field/QCXFinalDateTimePickerField';
import { MediaType } from '../../utils/api/api-utils';
import SolicitacaoPagamentoUtils from '../../utils/general/solicitacao-pagamento/SolicitacaoPagamentoUtils';
import { fetchById as fetchFornecedorById } from '../../features/fornecedor-favorecido/FornecedorAPI';
import { fetchById as fetchMoedaById } from '../../features/moeda/moedaAPI';
import MoedaUtils from '../../utils/general/moeda/MoedaUtils';
import { formatBrazilianNumericDecimal } from '../../utils/hooks/form/field/formatters';
import QCXInfoAlert from '../../shared-components/alert/QCXInfoAlert';
import QCXSelectDespesaReceitaAutocomplete from '../../shared-components/select-despesa-receita/QCXSelectDespesaReceitaAutocomplete';
import { solicitacaoPagamentoAPI } from '../../features/solicitacao-pagamento/solicitacaoPagamentoAPI';
import {
  resetBalances,
  setBalances,
  failure,
  setError,
} from '../../features/solicitacao-pagamento/solicitacaoPagamentoSlice';
import { selectRelatedModelBalances } from '../../features/solicitacao-pagamento/solicitacaoPagamentoSelectors';
import { despesaReceitaAPI } from '../../features/despesa-receita/despesaReceitaAPI';
import QCXFinalTextField from '../../shared-components/final-text-field/QCXFinalTextField';
import QCXFinalNumericIntegerField from '../../shared-components/final-numeric-integer-field/QCXFinalNumericIntegerField';
import QCXFinalMultilineTextField from '../../shared-components/final-text-field/QCXFinalMultilineTextField';
import { vinculoSolicitacaoPagamentoDespesaActions, vinculoSolicitacaoPagamentoDespesaSelectors } from '../../features/solicitacao-pagamento/vinculoSolicitacaoPagamentoDespesaSlice';
import QCXFinalBondManagerOldBatch from '../../shared-components/final-gerenciador-relacionamento/QCXFinalBondManagerOldBatch';

const useStyles = makeStyles(() => ({
  gridFields: {
    paddingBottom: '16px',
  },
  subtitle: {
    margin: '20px 0',
  },
}));

function DisableSalvarMultiplaWatcher({ values, setDisabled }) {
  const disabledAgora =
    !!values?.multipla &&
    (!Array.isArray(values?.despesasAdicionais) || values.despesasAdicionais.length === 0);

  const prevRef = React.useRef(disabledAgora);

  useEffect(() => {
    if (prevRef.current !== disabledAgora) {
      setDisabled(disabledAgora);
      prevRef.current = disabledAgora;
    }
  }, [disabledAgora, setDisabled]);

  return null;
}

function MultiplaToggleWatcher({ form, values }) {
  const prevRef = React.useRef(!!values?.multipla);

  useEffect(() => {
    if (!form) return;

    const prev = prevRef.current;
    const atual = !!values?.multipla;

    if (!prev && atual) {
      const lista = Array.isArray(values?.despesasAdicionais) ? values.despesasAdicionais : [];

      if (!Array.isArray(values?.despesasAdicionais)) {
        form.change('despesasAdicionais', []);
      }

      if (lista.length === 0) {
        form.change('ignorableFields.despesaLancamento', undefined);
      }
    }

    if (prev && !atual) {
      const lista = Array.isArray(values?.despesasAdicionais) ? values.despesasAdicionais : [];
      if (lista.length > 0) {
        const primeira = lista[0];

        form.change('despesaReceita.id', primeira?.despesaReceita?.id);
        form.change('moeda.id', primeira?.moeda?.id);
        form.change('fornecedor.id', primeira?.fornecedor?.id);
        form.change('favorecido.id', primeira?.favorecido?.id);

        form.change('contaBancariaPagamento', primeira?.contaBancariaPagamento);
        form.change('formaPagamento', primeira?.formaPagamento);
        form.change('numeroDocumento', primeira?.numeroDocumento);
        form.change('observacaoPagamento', primeira?.observacao);
        form.change('valorPagarMoeda', primeira?.valorPagarMoeda);
      }

      form.change('despesasAdicionais', []);
      form.change('ignorableFields.despesaLancamento', undefined);
    }

    prevRef.current = atual;
  }, [form, values?.multipla]);

  return null;
}
function MultiplaDespesasWatcher({ form, values, isMultipla }) {
  const despesasAdicionais = Array.isArray(values?.despesasAdicionais)
    ? values.despesasAdicionais
    : [];

  useEffect(() => {
    if (!isMultipla || !form) return;

    const totalNumerico = despesasAdicionais.reduce((acumulado, despesa) => {
      const valor = normalizeNumeral(despesa?.valorPagarMoeda) || 0;
      return acumulado + valor;
    }, 0);

    const totalFormatado = unnormalizeNumeral(
      totalNumerico,
      formatBrazilianNumericDecimal(2)
    );

    if (values?.valorOriginalMoeda !== totalFormatado) {
      form.change('valorOriginalMoeda', totalFormatado);
    }

    if (!values?.alterarValorAPagar) {
      const valoresParaCalculo = {
        ...values,
        valorOriginalMoeda: totalFormatado,
      };

      const totalComAjustesNumerico = SolicitacaoPagamentoUtils.calculaValorTotal(valoresParaCalculo);
      const totalComAjustesFormatado = unnormalizeNumeral(
        totalComAjustesNumerico,
        formatBrazilianNumericDecimal(2)
      );

      if (values?.valorPagarMoeda !== totalComAjustesFormatado) {
        form.change('valorPagarMoeda', totalComAjustesFormatado);
      }
    }
  }, [
    isMultipla,
    form,

    JSON.stringify(despesasAdicionais),

    values?.alterarValorAPagar,

    values?.valorDescontoMoeda,
    values?.valorMultaMoeda,
    values?.valorJurosMoeda,
    values?.percentualDesconto,
    values?.percentualMulta,
    values?.percentualJuros,
  ]);

  return null;
}


const isUuid = (v) => typeof v === 'string' && v.includes('-');

const limparPayloadAntesDeEnviar = (values) => {
  const payload = _.cloneDeep(values);

  delete payload.draftFields;
  delete payload.ignorableFields;

  _.unset(payload, 'fornecedor.contaBancaria');
  _.unset(payload, 'favorecido.contaBancaria');

  if (Array.isArray(payload.despesasAdicionais)) {
    payload.despesasAdicionais = payload.despesasAdicionais.map((d) => {
      const desp = { ...d };

      if (isUuid(desp?.id)) {
        delete desp.id;
      }

      _.unset(desp, 'fornecedor.contaBancaria');
      _.unset(desp, 'favorecido.contaBancaria');
      _.unset(desp, 'fornecedorContaBancariaVisual');
      return desp;
    });
  }

  return payload;
};


export default function QCXSolicitacaoPagamentoFinanceiroForm({
  isCreate,
  isConsult,
  isUpdate,
  initialValues,
  handleSubmit,
  handleChangeToConsult,
  handleChangeToUpdate,
  handleCancelUpdate,
  tableRows,
  disableUpdate,
  liberaMultipla,
  isContasAPagarView = false,
  ...restProps
}) {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const modeParam = useModeParam();

  const classes = useStyles();

  const clientAndProcessBalances = useSelector(selectRelatedModelBalances);

  const [isActivate, setIsActivate] = useState('');

  const [disableSalvarMultiplaSemDespesas, setDisableSalvarMultiplaSemDespesas] = useState(false);

  const [dupDialogStatus, setDupDialogStatus] = useState(CLOSED_STATUS);
  const [despesaParaDuplicar, setDespesaParaDuplicar] = useState(null);

  const onClickProcesso = (key) => {
    setIsActivate(() => (isActivate !== key ? key : ''));
  };

  const handleOpenDuplicate = useCallback((row) => {
    setDespesaParaDuplicar(row);
    setDupDialogStatus(OPEN_STATUS);
  }, []);


  const followUp = useMemo(() => initialValues?.followUp, [initialValues]);

  const columns = useMemo(
    () => [
      {
        field: 'processo',
        headerName: t('com.muralis.qcx.processo'),
        flex: 50,
        type: 'string',
        headerAlign: 'center',
        align: 'center',
        valueGetter: ({ row }) => row?.processo || '-',
      },
      {
        field: 'cliente',
        headerName: t('com.muralis.qcx.cliente.label'),
        flex: 170,
        type: 'string',
        headerAlign: 'center',
        align: 'center',
        valueGetter: ({ row }) => row?.cliente || '-',
      },
      {
        field: 'servico',
        headerName: t('com.muralis.qcx.servico.labelSingular'),
        flex: 100,
        type: 'string',
        valueGetter: ({ row }) => row?.servico || '-',
      },
      {
        field: 'viaTransporte',
        headerName: t('com.muralis.qcx.transporte.viaTransporte'),
        flex: 100,
        type: 'string',
        headerAlign: 'center',
        align: 'center',
        valueGetter: ({ row }) => row?.viaTransporte || '-',
      },
    ],
    []
  );

  useEffect(() => {
    const ganhoProcesso = initialValues?.ganhoProcesso;
    const perdaProcesso = initialValues?.perdaProcesso;

    if (ganhoProcesso) {
      setIsActivate(SolicitacaoPagamentoUtils.GANHO_PROCESSO);
      return;
    }

    if (perdaProcesso) {
      setIsActivate(SolicitacaoPagamentoUtils.PERDA_PROCESSO);
    }
  }, [initialValues]);

  useEffect(() => {
    (async () => {
      if (followUp?.id) {
        const response = await solicitacaoPagamentoAPI.fetchClientAndProcessBalances(followUp?.id);
        if (response?.status === 200) {
          dispatch(setBalances(response?.data));
        }
      }
    })();
  }, [followUp?.id, dispatch]);

  useEffect(() => {
    (async () => {
      if (!restProps?.form) {
        return;
      }

      if (!isCreate && initialValues?.favorecido?.id) {
        const response = await fetchFornecedorById(initialValues?.favorecido?.id);
        const contaBancariaFavorecido = response?.data?.contaBancaria;
        if (response?.status === 200 && contaBancariaFavorecido) {
          restProps.form.change(
            'favorecido.contaBancaria',
            contaBancariaFavorecido
          );
        }
      }

      if (!initialValues?.multipla) {
        if (!isCreate && initialValues?.fornecedor?.id) {
          const response = await fetchFornecedorById(initialValues?.fornecedor?.id);
          const contaBancariaFornecedor = response?.data?.contaBancaria;
          if (response?.status === 200 && contaBancariaFornecedor) {
            restProps.form.change('fornecedor.contaBancaria', contaBancariaFornecedor);
          }
        }
        return;
      }

      if (
        !isCreate &&
        Array.isArray(initialValues?.despesasAdicionais) &&
        initialValues.despesasAdicionais.length > 0
      ) {
        const despesasAtualizadas = await Promise.all(
          initialValues.despesasAdicionais.map(async (d) => {
            let fornecedorAtualizado = d.fornecedor;
            let favorecidoAtualizado = d.favorecido;
            let despesaReceitaAtualizada = d.despesaReceita;

            if (d?.despesaReceita?.id && !d?.despesaReceita?.descricao && !d?.despesaReceita?.description) {
              try {
                const respDespesa = await despesaReceitaAPI.fetchById(d.despesaReceita.id);
                if (respDespesa?.status === 200 && respDespesa?.data) {
                  despesaReceitaAtualizada = respDespesa.data;
                }
              } catch (e) {
                // mantém como veio
              }
            }

            if (d?.fornecedor?.id) {
              const respFornecedor = await fetchFornecedorById(d.fornecedor.id);
              if (respFornecedor?.status === 200) {
                fornecedorAtualizado = d.fornecedor;
              }
            }

            if (d?.favorecido?.id) {
              const respFavorecido = await fetchFornecedorById(d.favorecido.id);
              if (respFavorecido?.status === 200) {
                favorecidoAtualizado = d.favorecido;
              }
            }

            return {
              ...d,
              despesaReceita: despesaReceitaAtualizada,
              fornecedor: fornecedorAtualizado,
              favorecido: favorecidoAtualizado,
            };
          })
        );

        restProps.form.change('despesasAdicionais', despesasAtualizadas);
      }
    })();
  }, [initialValues, isCreate]);

  useEffect(() => () => dispatch(resetBalances()), []);

  const taxaCambialValidators = useMemo(() => useValidators([requiredValidator, maxValue(9.99999)]), []);

  const dataValidators = useMemo(
    () =>
      useValidators([
        (value) => {
          if (!value) {
            return undefined;
          }
          return requiredValidator(value) || validateWeekDay(value);
        },
      ]),
    []
  );

  const despesaReducerConfig = useMemo(
    () => ({
      selectors: { selectStatus: vinculoSolicitacaoPagamentoDespesaSelectors.selectStatus },
      actions: {
        loading: vinculoSolicitacaoPagamentoDespesaActions.loading,
        resetStatus: vinculoSolicitacaoPagamentoDespesaActions.resetStatus,
      },
    }),
    []
  );

  const despesaFormProps = useMemo(
    () => ({ rootName: 'ignorableFields.despesaLancamento' }),
    []
  );

  const despesaListProps = useMemo(
    () => ({
      name: 'despesasAdicionais',
      columns: [
        {
          field: 'despesa',
          headerName: t('com.muralis.qcx.despesa.label'),
          flex: 220,
          valueGetter: ({ row }) =>
            row?.despesaReceita?.descricao || row?.despesaReceita?.description || '-',
        },
        {
          field: 'fornecedor',
          headerName: t('com.muralis.qcx.fornecedor.label'),
          flex: 220,
          valueGetter: ({ row }) =>
            row?.fornecedor?.pessoa?.nome ||
            row?.fornecedor?.nome ||
            row?.fornecedor?.description ||
            '-',
        },
        {
          field: 'numeroDocumento',
          headerName: t('com.muralis.qcx.documento.numeroDocumento'),
          flex: 150,
          valueGetter: ({ row }) => row?.numeroDocumento || '-',
        },
        {
          field: 'numeroNfse',
          headerName: 'Número NFSe',
          flex: 120,
          valueGetter: ({ row }) => row?.numeroNfse || '-',
        },
        {
          field: 'valor',
          headerName: t('com.muralis.qcx.valorSolicitado'),
          headerAlign: 'right',
          align: 'right',
          flex: 140,
          valueGetter: ({ row }) => row?.valorPagarMoeda || '',
        },
      ],
    }),
    [t]
  );

  const handleAddDespesaMultipla = useCallback(
    async (current, list, handleSuccessAdd, tools) => {
      const { form, values } = tools.formUtils;

      const requiredPaths = [
        'despesaReceita.id',
        'valorPagarMoeda',
        'fornecedor.id',
        'favorecido.id',
        // ...(SolicitacaoPagamentoUtils.isOperacional(values?.tipo) ? ['numeroNfse'] : []),
        // 'numeroDocumento',
      ];

      const requiredLabels = {
        'despesaReceita.id': 'Despesa',
        'valorPagarMoeda': 'Valor solicitado',
        'fornecedor.id': 'Fornecedor',
        'favorecido.id': 'Favorecido',
        // 'numeroNfse': 'Número NFSe',
        // 'numeroDocumento': 'Número do documento',
      };

      const faltando = requiredPaths
        .filter((path) => {
          const v = _.get(current, path);

          if (path === 'contaBancariaPagamento') {
            if (!v) return true;
            if (typeof v === 'object') return !v.id;
            return false;
          }

          if (typeof v === 'string') return !v.trim();

          return !v;
        })
        .map((path) => requiredLabels[path] || path);

      if (faltando.length) {
        throw new Error(`Preencha antes de adicionar: ${faltando.join(', ')}.`);
      }

      let despesaReceita = current?.despesaReceita;
      if (current?.despesaReceita?.id && !despesaReceita?.descricao && !despesaReceita?.description) {
        const resp = await despesaReceitaAPI.fetchById(current.despesaReceita.id);
        if (resp?.status === 200 && resp?.data) despesaReceita = resp.data;
      }

      const novoItem = {
        ...current,
        id: current?.id || uuid(),
        despesaReceita,
        moeda: values?.moeda,
      };

      handleSuccessAdd([...(list || []), novoItem]);

      setTimeout(() => {
        form.batch(() => {
          form.change('ignorableFields.despesaLancamento.fornecedor.id', current?.fornecedor?.id);

          form.change('ignorableFields.despesaLancamento.favorecido.id', current?.favorecido?.id);

          form.change('ignorableFields.despesaLancamento.valorPagarMoeda', undefined);

          form.change('ignorableFields.despesaLancamento.despesaReceita.id', undefined);
          form.change('ignorableFields.despesaLancamento.despesaReceita', undefined);
          form.change('ignorableFields.despesaLancamento.numeroDocumento', undefined);
          form.change('ignorableFields.despesaLancamento.numeroNfse', undefined);
          form.change('ignorableFields.despesaLancamento.observacao', undefined);
        });
      }, 0);
    },
    []
  );

  const handleUpdateDespesaMultipla = useCallback(
    async (current, list, handleSuccessUpdate, tools) => {
      const { values } = tools.formUtils;

      const oldItem = (list || []).find((d) => d?.id === current?.id);

      const oldDespesaId = oldItem?.despesaReceita?.id;
      const newDespesaId = current?.despesaReceita?.id;

      let despesaReceita = current?.despesaReceita;

      const mudouDespesa = !!newDespesaId && newDespesaId !== oldDespesaId;

      if (mudouDespesa) {
        try {
          const resp = await despesaReceitaAPI.fetchById(newDespesaId);
          if (resp?.status === 200 && resp?.data) despesaReceita = resp.data;
        } catch (e) {
          despesaReceita = { id: newDespesaId };
        }
      } else {
        if (newDespesaId && !despesaReceita?.descricao && !despesaReceita?.description) {
          const resp = await despesaReceitaAPI.fetchById(newDespesaId);
          if (resp?.status === 200 && resp?.data) despesaReceita = resp.data;
        }
      }

      const currentFixed = {
        ...current,
        despesaReceita,
        moeda: values?.moeda,
      };

      const updated = (list || []).map((d) => (d?.id === currentFixed?.id ? currentFixed : d));
      handleSuccessUpdate(updated);
    },
    []
  );

  const handleRemoveDespesaMultipla = useCallback(async ({ target, list, tools }) => {
    const updated = (list || []).filter((d) => d?.id !== target?.id);
    tools.formUtils.form.change('despesasAdicionais', updated);
  }, []);

  const configureDespesaReceitaFilterPredicateWith = useMemo(
    () => [
      {
        name: 'tipo',
        value: initialValues?.tipo,
      },
    ],
    [initialValues]
  );

  const formControlButtons = useMemo(
    () => ({
      create: {
        description: t('com.muralis.qcx.acoes.salvar').toUpperCase(),
        disabled: disableSalvarMultiplaSemDespesas,
      },
      cancel: {
        description: t('com.muralis.qcx.acoes.cancelar').toUpperCase(),
      },
      edit: {
        hidden: disableUpdate || modeParam.readOnly,
      },
    }),
    [disableUpdate, modeParam, disableSalvarMultiplaSemDespesas]
  );

  const documentoPagamentoGetter = useCallback((object) => {
    if (Array.isArray(object)) {
      return object;
    }
    if (object) {
      return [object];
    }
    return [];
  }, []);

  const documentoPagamentoNameGetter = useCallback((file) => {
    if (file?.id) {
      return file?.nome;
    }

    return file?.name;
  }, []);

  const dataSolicitacao = useMemo(() => getCurrentDate().toDate(), []);

  const internalInitialValues = useMemo(
    () =>
      isCreate
        ? {
          ...initialValues,
          dataSolicitacao,
          status: SolicitacaoPagamentoUtils.SOLICITACAO_PENDENTE,
          valorSaldoCliente: isValid(clientAndProcessBalances?.valorSaldoCliente)
            ? unnormalizeNumeral(clientAndProcessBalances?.valorSaldoCliente, formatBrazilianNumericDecimal(2, true))
            : undefined,
          valorSaldoProcesso: isValid(clientAndProcessBalances?.valorSaldoProcesso)
            ? unnormalizeNumeral(clientAndProcessBalances?.valorSaldoProcesso, formatBrazilianNumericDecimal(2, true))
            : undefined,
        }
        : {
          ...initialValues,
          valorSaldoCliente: isValid(clientAndProcessBalances?.valorSaldoCliente)
            ? unnormalizeNumeral(clientAndProcessBalances?.valorSaldoCliente, formatBrazilianNumericDecimal(2, true))
            : undefined,
          valorSaldoProcesso: isValid(clientAndProcessBalances?.valorSaldoProcesso)
            ? unnormalizeNumeral(clientAndProcessBalances?.valorSaldoProcesso, formatBrazilianNumericDecimal(2, true))
            : undefined,
        },
    [isCreate, dataSolicitacao, clientAndProcessBalances, initialValues]
  );

  const dataGridRows = useMemo(() => tableRows, [tableRows]);

  const onGanhoProcessoChange = useCallback(
    (form, values) => (value) => {
      if (value) {
        form.change('perdaProcesso', false);
      }

      if (!value && !values?.perdaProcesso) {
        form.change('observacaoPagamento', undefined);
      }
    },
    []
  );

  const onPerdaProcessoChange = useCallback(
    (form, values) => (value) => {
      if (value) {
        form.change('ganhoProcesso', false);
      }

      if (!value && !values?.ganhoProcesso) {
        form.change('observacaoPagamento', undefined);
      }
    },
    []
  );

  const onFavorecidoChange = useCallback(
    (form) => async (value) => {
      if (!value || isConsult) return;

      const response = await fetchFornecedorById(value);
      const conta = response?.data?.contaBancaria;

      if (response?.status === 200) {
        form.change('favorecido.contaBancaria', conta || undefined);

        if (conta?.id) {
          form.change('contaBancariaPagamento.id', conta.id);
        }
      }
    },
    [isConsult]
  );

  const onFornecedorChange = useCallback(
    (form) => async (value) => {
      if (!value || isConsult) return;

      const response = await fetchFornecedorById(value);
      const fornecedor = response?.data;
      const conta = fornecedor?.contaBancaria;

      form.change('fornecedor.contaBancaria', conta || undefined);

      if (fornecedor?.active && fornecedor?.favorecido) {
        form.change('favorecido.id', fornecedor.id);
      }
    },
    [isConsult]
  );

  const onFornecedorDespesaMultiplaChange = useCallback(
    (form) => async (value) => {
      if (!value || isConsult) return;

      const resp = await fetchFornecedorById(value);
      if (resp?.status !== 200) return;

      const fornecedor = resp?.data;
      const contaFornecedor = fornecedor?.contaBancaria;

      form.batch(() => {
        form.change('ignorableFields.despesaLancamento.fornecedor', fornecedor || { id: value });

        // espelha favorecido
        form.change('ignorableFields.despesaLancamento.favorecido.id', fornecedor?.id);

        // (opcional) manter conta bancária do favorecido "visual"
        form.change('ignorableFields.despesaLancamento.favorecido.contaBancaria', contaFornecedor || undefined);

        // // conta pagamento default
        // if (contaFornecedor?.id) {
        //   form.change('ignorableFields.despesaLancamento.contaBancariaPagamento.id', contaFornecedor.id);
        // }
      });
    },
    [isConsult]
  );


  const onFavorecidoDespesaMultiplaChange = useCallback(
    (form) => async (value) => {
      if (!value || isConsult) return;

      const response = await fetchFornecedorById(value);
      if (response?.status !== 200) return;

      const favorecido = response?.data;
      const conta = favorecido?.contaBancaria;

      form.batch(() => {
        form.change('ignorableFields.despesaLancamento.favorecido', favorecido || { id: value });
        form.change('ignorableFields.despesaLancamento.favorecido.contaBancaria', conta || undefined);

        // if (conta?.id) {
        //   form.change('ignorableFields.despesaLancamento.contaBancariaPagamento.id', conta.id);
        // }
      });
    },
    [isConsult]
  );


  const onMoedaChange = useCallback(
    (form) => async (value) => {
      if (value && !isConsult) {
        const response = await fetchMoedaById(value);
        const moeda = response?.data;

        if (response?.status === 200 && moeda?.code === MoedaUtils.BRASIL) {
          form.change('taxaCambio', '1,00000');
        }
      }
    },
    [isConsult]
  );

  const onDespesaReceitaChange = useCallback(
    (form) => async (value) => {
      const solicitacaoPagamentoOperacional = SolicitacaoPagamentoUtils.isOperacional(initialValues?.tipo);

      if (isConsult || solicitacaoPagamentoOperacional) {
        return;
      }

      if (value) {
        try {
          const response = await despesaReceitaAPI.fetchById(value);

          if (response?.status === 200) {
            const foundDespesaReceita = response?.data;

            if (foundDespesaReceita && !isEmpty(foundDespesaReceita)) {
              form.change('moeda.id', foundDespesaReceita?.moeda?.id);
            }
          }
        } catch (error) {
          const defaultMessage = t('com.muralis.qcx.mensagem.impossivelCarregarDadosReceitaDespesaSelecionada');
          let fullMessage = defaultMessage;

          if (error?.response) {
            fullMessage = `${defaultMessage}: ${error?.response?.data?.message}`;
          }

          if (error?.message) {
            fullMessage = `${defaultMessage}: ${error?.message}`;
          }

          dispatch(failure());
          dispatch(
            setError({
              message: fullMessage,
            })
          );
        }

        return;
      }

      form.resetFieldState('despesaReceita.id');
    },
    [isConsult, initialValues]
  );

  const handleValorMoedaOnBlur = useCallback(
    (form, values, fieldName = '') =>
      () => {
        if (!isConsult) {
          if (fieldName === 'valorPagarMoeda') {
            const valorPagarMoeda = normalizeNumeral(_.get(values, 'valorPagarMoeda')) || 0;
            const formattedNovoValorTotalMoeda = unnormalizeNumeral(valorPagarMoeda, formatBrazilianNumericDecimal(2));
            form.change('valorPagarMoeda', formattedNovoValorTotalMoeda);
            return;
          }

          const valorOriginalMoeda = normalizeNumeral(_.get(values, 'valorOriginalMoeda')) || 0;

          if (fieldName === 'valorOriginalMoeda') {
            const mapValorAndPercentualFields = SolicitacaoPagamentoUtils.mapValorMoedaAndValorPercentualFieldNames;

            const mapUpdatedValorMoedaAndPercentualFields = mapValorAndPercentualFields.map((value) => {
              const updatedValorMoeda = SolicitacaoPagamentoUtils.calculaValorMoedaByPercentual({
                valorOriginalMoeda,
                values,
                fields: value,
              });

              const formattedValorMoedaField = unnormalizeNumeral(
                updatedValorMoeda?.value,
                formatBrazilianNumericDecimal(2)
              );

              return {
                ...value,
                valorMoedaField: formattedValorMoedaField,
              };
            });

            mapUpdatedValorMoedaAndPercentualFields.forEach(({ valorField, valorMoedaField }) => {
              const novoValorMoeda = normalizeNumeral(valorMoedaField);

              if (novoValorMoeda) {
                form.change(valorField, valorMoedaField);
              }
            });

            const updatedValoresMoedaValues = mapUpdatedValorMoedaAndPercentualFields.reduce(
              (previous, currentKey) => ({
                ...previous,
                [currentKey.valorField]: currentKey.valorMoedaField,
              }),
              {}
            );

            const newValues = {
              ...values,
              ...updatedValoresMoedaValues,
            };

            const updatedPercentuaisFields = SolicitacaoPagamentoUtils.calculaPercentuaisByValorMoeda(newValues) || [];

            updatedPercentuaisFields
              .filter((obj) => obj !== undefined)
              .forEach(({ name, value }) => {
                const formattedPercentual = unnormalizeNumeral(value, formatBrazilianNumericDecimal(5));

                form.change(name, formattedPercentual);
              });

            let valorPagarMoeda;

            if (values?.alterarValorAPagar) {
              valorPagarMoeda = normalizeNumeral(_.get(values, 'valorPagarMoeda')) || 0;
            } else {
              valorPagarMoeda = SolicitacaoPagamentoUtils.calculaValorTotal(newValues);
            }

            const formattedNovoValorTotalMoeda = unnormalizeNumeral(valorPagarMoeda, formatBrazilianNumericDecimal(2));
            form.change('valorPagarMoeda', formattedNovoValorTotalMoeda);

            return;
          }

          let valorPagarMoeda;

          if (values?.alterarValorAPagar) {
            valorPagarMoeda = normalizeNumeral(_.get(values, 'valorPagarMoeda')) || 0;
          } else {
            valorPagarMoeda = SolicitacaoPagamentoUtils.calculaValorTotal(values);
          }

          const formattedNovoValorTotalMoeda = unnormalizeNumeral(valorPagarMoeda, formatBrazilianNumericDecimal(2));
          form.change('valorPagarMoeda', formattedNovoValorTotalMoeda);

          if (valorOriginalMoeda) {
            const updatedPercentuaisFields = SolicitacaoPagamentoUtils.calculaPercentuaisByValorMoeda(values) || [];

            updatedPercentuaisFields
              .filter((obj) => obj !== undefined)
              .forEach(({ name, value }) => {
                const formattedPercentual = unnormalizeNumeral(value, formatBrazilianNumericDecimal(5));

                form.change(name, formattedPercentual);
              });
          }
        }
      },
    [isConsult]
  );

  const handlePercentualOnBlur = useCallback(
    (form, values, fieldName = '') =>
      () => {
        if (!isConsult) {
          const mapValorAndPercentualFields = SolicitacaoPagamentoUtils.mapValorMoedaAndValorPercentualFieldNames;

          const valorPercentualField = mapValorAndPercentualFields.find(
            ({ percentualField }) => percentualField === fieldName
          );

          const valorOriginalMoeda = normalizeNumeral(_.get(values, 'valorOriginalMoeda')) || 0;

          if (valorOriginalMoeda) {
            const updatedValorMoeda = SolicitacaoPagamentoUtils.calculaValorMoedaByPercentual({
              valorOriginalMoeda,
              values,
              fields: valorPercentualField,
            });

            const formattedPercentual = unnormalizeNumeral(updatedValorMoeda?.value, formatBrazilianNumericDecimal(2));

            form.change(updatedValorMoeda?.name, formattedPercentual);

            const updatedValues = {
              ...values,
              [updatedValorMoeda?.name]: formattedPercentual,
            };

            let valorPagarMoeda;

            if (values?.alterarValorAPagar) {
              valorPagarMoeda = normalizeNumeral(_.get(values, 'valorPagarMoeda')) || 0;
            } else {
              valorPagarMoeda = SolicitacaoPagamentoUtils.calculaValorTotal(updatedValues);
            }

            const formattedNovoValorTotalMoeda = unnormalizeNumeral(valorPagarMoeda, formatBrazilianNumericDecimal(2));
            form.change('valorPagarMoeda', formattedNovoValorTotalMoeda);
          }
        }
      },
    [isConsult]
  );

  const onChangeListeners = useMemo(
    () => [
      {
        name: 'ganhoProcesso',
        fn: onGanhoProcessoChange,
      },
      {
        name: 'perdaProcesso',
        fn: onPerdaProcessoChange,
      },
      {
        name: 'fornecedor.id',
        fn: onFornecedorChange,
      },
      {
        name: 'favorecido.id',
        fn: onFavorecidoChange,
      },
      {
        name: 'moeda.id',
        fn: onMoedaChange,
      },
      {
        name: 'despesaReceita.id',
        fn: onDespesaReceitaChange,
      },
      {
        name: 'ignorableFields.despesaLancamento.fornecedor.id',
        fn: onFornecedorDespesaMultiplaChange,
      },
      {
        name: 'ignorableFields.despesaLancamento.favorecido.id',
        fn: onFavorecidoDespesaMultiplaChange,
      },
    ],
    [onGanhoProcessoChange, onPerdaProcessoChange, onFornecedorChange, onFavorecidoChange, onMoedaChange, onDespesaReceitaChange, onFornecedorDespesaMultiplaChange, onFavorecidoDespesaMultiplaChange]
  );

  const downloader = useDownloader({
    autoDownload: true,
  });

  const handleSubmitSanitizado = useCallback((values) => {
    const payload = limparPayloadAntesDeEnviar(values);
    return handleSubmit(payload);
  }, [handleSubmit]);

  return (
    <QCXFinalForm
      isConsult={isConsult}
      isUpdate={isUpdate}
      initialValues={internalInitialValues}
      controlButtons={formControlButtons}
      handleSubmitValues={handleSubmitSanitizado}
      handleChangeToUpdate={handleChangeToUpdate}
      handleCancelUpdate={handleCancelUpdate}
      onChangeListeners={onChangeListeners}
      {...restProps}
    >
      {({ form, values }) => {

        const handleDuplicateSubmitLocal = useCallback(
          async (dialogValues) => {
            try {
              if (!despesaParaDuplicar) return;

              const newDespesaId = dialogValues?.despesaReceita?.id;
              let despesaReceita = { id: newDespesaId };

              if (newDespesaId) {
                const resp = await despesaReceitaAPI.fetchById(newDespesaId);
                if (resp?.status === 200 && resp?.data) despesaReceita = resp.data;
              }

              const novoItem = {
                ...despesaParaDuplicar,
                id: uuid(),
                despesaReceita,
                valorPagarMoeda: dialogValues?.valorPagarMoeda,
                moeda: values?.moeda || despesaParaDuplicar?.moeda,
              };

              const listaAtual = Array.isArray(values?.despesasAdicionais) ? values.despesasAdicionais : [];
              form.change('despesasAdicionais', [...listaAtual, novoItem]);

              setDupDialogStatus(CLOSED_STATUS);
              setDespesaParaDuplicar(null);
            } catch (e) {
              console.error('[DUPLICAR] erro:', e);
              throw e;
            }
          },
          [despesaParaDuplicar, values?.moeda, values?.despesasAdicionais, form]
        );
        const isMultipla = !!values?.multipla;

        return (
          <>
            <MultiplaToggleWatcher form={form} values={values} />

            <DisableSalvarMultiplaWatcher
              values={values}
              setDisabled={setDisableSalvarMultiplaSemDespesas}
            />

            <MultiplaDespesasWatcher
              form={form}
              values={values}
              isMultipla={isMultipla}
            />

            {disableUpdate && (
              <Grid
                item
                xs={12}
                style={{
                  marginTop: '0.5rem',
                  paddingBottom: '16px',
                }}
              >
                <QCXInfoAlert>
                  <Trans i18nKey="com.muralis.qcx.numerarioImportacao.avisoAlteracoesBloqueadasStatus">
                    <b>
                      {{
                        status: values?.status?.replaceAll('_', ' '),
                      }}
                    </b>
                  </Trans>
                </QCXInfoAlert>
              </Grid>
            )}

            {values?.status === SolicitacaoPagamentoUtils.RECUSADO_PELO_APROVADOR && (
              <Grid item xs={12}>
                <QCXFinalMultilineTextField
                  id="multiline-text-field-justificativa"
                  key="multiline-text-field-justificativa"
                  name="situacaoAprovacao.justificativa"
                  label={t('com.muralis.qcx.justificativa')}
                  rows={10}
                  disabled
                />
              </Grid>
            )}

            <Grid item container spacing={3}>
              {/* GRID DO PROCESSO (operacional) */}
              {SolicitacaoPagamentoUtils.isOperacional(values?.tipo) && (
                <Grid item className={classes.gridFields} xs={12} sm={12} md={12}>
                  <QCXDataGrid columns={columns} rows={dataGridRows} />
                </Grid>
              )}

              {/* DATA DA SOLICITAÇÃO (ambos) */}
              <Grid item className={classes.gridFields} xs={12} sm={6} md={4}>
                <QCXFinalDateTimePickerField
                  id="date-picker-data-solicitacao-field"
                  key="date-picker-data-solicitacao-field"
                  name="dataSolicitacao"
                  label={t('com.muralis.qcx.numerarioImportacao.dataSolicitacao')}
                  disabled
                />
              </Grid>

              {/* SALDOS (operacional) */}
              {SolicitacaoPagamentoUtils.isOperacional(values?.tipo) && (
                <>
                  <Grid item xs={12} sm={12} md={4}>
                    <QCXFinalAlternativeCurrencyField
                      id="financeiro-valor-saldo-processo-field"
                      key="financeiro-valor-saldo-processo-field"
                      name="valorSaldoProcesso"
                      label={t('com.muralis.qcx.valorSaldoProcesso')}
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={4}>
                    <QCXFinalAlternativeCurrencyField
                      id="financeiro-valor-saldo-cliente-field"
                      key="financeiro-valor-saldo-cliente-field"
                      name="valorSaldoCliente"
                      label={t('com.muralis.qcx.valorSaldoCliente')}
                      disabled
                    />
                  </Grid>
                </>
              )}

              {/* CHECKBOX MÚLTIPLA (subiu pra cima) */}
              {liberaMultipla &&
                <Grid item xs={12} sm={12} md={4}>
                  <QCXFinalCheckboxField
                    id="checkbox-multipla"
                    name="multipla"
                    label="Solicitação múltipla"
                    disabled={isConsult || isContasAPagarView}
                  />
                </Grid>}

              {/* ============================= */}
              {/*   DESPESAS (MÚLTIPLA)         */}
              {/* ============================= */}
              {isMultipla && (
                <Grid item xs={12}>
                  <QCXFormTitle title="Despesas Adicionais" />

                  <QCXFinalBondManagerOldBatch
                    listProps={despesaListProps}
                    formProps={despesaFormProps}
                    reducerConfig={despesaReducerConfig}
                    handleAdd={handleAddDespesaMultipla}
                    handleUpdate={handleUpdateDespesaMultipla}
                    handleRemove={handleRemoveDespesaMultipla}
                    handleDuplicate={(row) => handleOpenDuplicate(row)}
                    disableDuplicate={isConsult || isContasAPagarView}
                    disableDefaultRemove
                    disableRemove={isConsult || isContasAPagarView}
                    disableAdd={isConsult || isContasAPagarView}
                    readOnlyMode={isConsult || isContasAPagarView}
                  >
                    <>
                      <QCXDuplicateDespesaDialogForm
                        openStatus={dupDialogStatus}
                        handleFormStatus={setDupDialogStatus}
                        initialValues={despesaParaDuplicar}
                        filterParams={configureDespesaReceitaFilterPredicateWith}
                        handleOnSubmit={handleDuplicateSubmitLocal}
                      />
                      <Grid item xs={12} md={6} className={classes.gridFields}>
                        <QCXSelectDespesaReceitaAutocomplete
                          id="select-despesa-receita-multipla"
                          name="ignorableFields.despesaLancamento.despesaReceita.id"
                          label={t('com.muralis.qcx.despesa.label')}
                          fullWidth
                          initialValues={values}
                          fieldProps={{ validate: undefined }}
                        />
                      </Grid>

                      <Grid item xs={12} md={6} className={classes.gridFields}>
                        <QCXFinalAlternativeCurrencyField
                          id="valor-despesa-multipla"
                          name="ignorableFields.despesaLancamento.valorPagarMoeda"
                          label={t('com.muralis.qcx.valorSolicitado')}
                          fullWidth
                          decimalPlaces={2}
                          initialValues={values}
                          fieldProps={{ validate: undefined }}
                        />
                      </Grid>

                      <Grid item xs={12} md={6} className={classes.gridFields}>
                        <QCXSelectFornecedorAutocomplete
                          id="fornecedor-despesa-multipla"
                          name="ignorableFields.despesaLancamento.fornecedor.id"
                          label={t('com.muralis.qcx.fornecedor.label')}
                          initialValues={values}
                          fullWidth
                          fieldProps={{ validate: undefined }}
                        />
                      </Grid>



                      <Grid item xs={12} md={6} className={classes.gridFields}>
                        <QCXSelectFavorecidoAutocomplete
                          id="favorecido-despesa-multipla"
                          name="ignorableFields.despesaLancamento.favorecido.id"
                          label={t('com.muralis.qcx.favorecido')}
                          initialValues={values}
                          fullWidth
                          fieldProps={{ validate: undefined }}
                          disabled
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <QCXSelectContaBancariaAutocompleteField
                          id="autocomplete-select-conta-bancaria-fornecedor-field"
                          key="autocomplete-select-conta-bancaria-fornecedor-field"
                          name="ignorableFields.despesaLancamento.fornecedor.contaBancaria"
                          label="Conta Bancária do Fornecedor"
                          initialValues={values}
                          disabled
                          fieldProps={{ validate: undefined }}
                          filtraControlaSaldo={SolicitacaoPagamentoUtils.isAdministrativa(values?.tipo)}
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <QCXSelectContaBancariaAutocompleteField
                          id="autocomplete-select-conta-bancaria-favorecido-field"
                          key="autocomplete-select-conta-bancaria-favorecido-field"
                          name="ignorableFields.despesaLancamento.favorecido.contaBancaria"
                          label="Conta Bancária do Favorecido"
                          initialValues={values}
                          disabled
                          fieldProps={{ validate: undefined }}
                          filtraControlaSaldo={SolicitacaoPagamentoUtils.isAdministrativa(values?.tipo)}
                        />
                      </Grid>

                      <Grid item xs={12} md={6} className={classes.gridFields}>
                        <QCXFinalTextField
                          id="doc-despesa-multipla"
                          name="ignorableFields.despesaLancamento.numeroDocumento"
                          label={t('com.muralis.qcx.documento.numeroDocumento')}
                          fullWidth
                          fieldProps={{ validate: undefined }}
                        />
                      </Grid>

                      {SolicitacaoPagamentoUtils.isOperacional(values?.tipo) && (
                        <Grid item xs={12} md={6} className={classes.gridFields}>
                          <QCXFinalTextField
                            id="numero-nfse-despesa-multipla"
                            name="ignorableFields.despesaLancamento.numeroNfse"
                            label="Numero NFSe"
                            fullWidth
                            disabled={isConsult || isContasAPagarView}
                            fieldProps={{ validate: undefined }}
                          />
                        </Grid>
                      )}

                      <Grid item xs={12} className={classes.gridFields}>
                        <QCXFinalMultilineTextField
                          id="obs-despesa-multipla"
                          name="ignorableFields.despesaLancamento.observacao"
                          label={t('com.muralis.qcx.observacao')}
                          fullWidth
                          rows={3}
                        />
                      </Grid>
                    </>
                  </QCXFinalBondManagerOldBatch>
                </Grid>
              )}



              {/* ============================= */}
              {/*   FLUXO NÃO MÚLTIPLO          */}
              {/* ============================= */}
              {!isMultipla && (
                <>
                  <Grid item xs={12} sm={12} md={12}>
                    <QCXFormTitle
                      title={t('com.muralis.qcx.despesa.labelPlural')}
                      boxProps={{
                        pt: 1,
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={6}>
                    <QCXSelectDespesaReceitaAutocomplete
                      id="autocomplete-select-field-despesa"
                      key="autocomplete-select-field-despesa"
                      name="despesaReceita.id"
                      label={t('com.muralis.qcx.despesa.labelPlural')}
                      initialValues={values}
                      disabled={isConsult || isContasAPagarView}
                      fieldProps={{ validate: requiredValidator }}
                      filterParams={configureDespesaReceitaFilterPredicateWith}
                      required
                    />
                  </Grid>
                </>)}
              <Grid item xs={12} sm={12} md={6}>
                <QCXSelectMoedaAutocomplete
                  id="select-field-moeda-geral"
                  key="select-field-moeda-geral"
                  name="moeda.id"
                  label={t('com.muralis.qcx.moeda.label')}
                  disabled={isConsult || isContasAPagarView}
                  initialValues={values}
                  fieldProps={{ validate: requiredValidator }}
                  defaultCode={
                    SolicitacaoPagamentoUtils.isAdministrativa(values?.tipo) ? '790' : undefined
                  }
                  required
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6}>
                <QCXFinalAlternativeCurrencyField
                  id="financeiro-valor-taxa-cambio-field"
                  key="financeiro-valor-taxa-cambio-field"
                  name="taxaCambio"
                  label={t('com.muralis.qcx.taxaCambio')}
                  validate={taxaCambialValidators}
                  disabled={isConsult || isContasAPagarView}
                  scale={5}
                  required
                />
              </Grid>

              {!isMultipla && (
                <>


                  <Grid item xs={12} sm={12} md={6}>
                    <QCXSelectFornecedorAutocomplete
                      id="select-field-fornecedor"
                      key="select-field-fornecedor"
                      name="fornecedor.id"
                      label={t('com.muralis.qcx.fornecedor.label')}
                      initialValues={values}
                      disabled={isConsult || isContasAPagarView}
                      fieldProps={{ validate: requiredValidator }}
                      required
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={6}>
                    <QCXSelectFavorecidoAutocomplete
                      id="select-field-favorecido"
                      key="select-field-favorecido"
                      name="favorecido.id"
                      label={t('com.muralis.qcx.favorecido')}
                      initialValues={values}
                      disabled={isConsult || isContasAPagarView}
                      fieldProps={{ validate: requiredValidator }}
                      required
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={6}>
                    <QCXSelectContaBancariaAutocompleteField
                      id="autocomplete-select-conta-bancaria-fornecedor-field"
                      key="autocomplete-select-conta-bancaria-fornecedor-field"
                      name="fornecedor.contaBancaria"
                      label="Conta Bancária do Fornecedor"
                      initialValues={values}
                      disabled
                      fieldProps={{ validate: undefined }}
                      filtraControlaSaldo={SolicitacaoPagamentoUtils.isAdministrativa(values?.tipo)}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={6}>
                    <QCXSelectContaBancariaAutocompleteField
                      id="autocomplete-select-conta-bancaria-favorecido-field"
                      key="autocomplete-select-conta-bancaria-favorecido-field"
                      name="favorecido.contaBancaria"
                      label="Conta Bancária do Favorecido"
                      initialValues={values}
                      disabled
                      fieldProps={{ validate: undefined }}
                      filtraControlaSaldo={SolicitacaoPagamentoUtils.isAdministrativa(values?.tipo)}
                    />
                  </Grid>

                </>)}

              <Grid item xs={12} sm={12} md={6}>
                <QCXFinalDatePickerField
                  id="date-picker-data-vencimento-field"
                  key="date-picker-data-vencimento-field"
                  name="dataVencimento"
                  label={t('com.muralis.qcx.dataVencimento')}
                  disabled={isConsult || isContasAPagarView}
                  validate={!isConsult && dataValidators}
                  required
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6}>
                <QCXFinalDatePickerField
                  id="date-picker-data-pagamento-field"
                  key="date-picker-data-pagamento-field"
                  name="dataPagamento"
                  label={t('com.muralis.qcx.pagamento.labelSigular')}
                  disabled
                  validate={!isConsult && dataValidators}
                  shouldDisableDate={isWeekend}
                />
              </Grid>


              <Grid item xs={12} sm={12} md={6}>
                <QCXSelectFormaPagamentoAutocompleteField
                  id="select-field-forma-pagamento"
                  key="select-field-forma-pagamento"
                  name="formaPagamento"
                  initialValues={values}
                  label={t('com.muralis.qcx.formaPagamento.label')}
                  disabled={isConsult || isContasAPagarView}
                />
              </Grid>



              <Grid item xs={12} sm={12} md={6}>
                <QCXSelectContaBancariaAutocompleteField
                  id="autocomplete-select-conta-bancaria-pagamento-field"
                  key="autocomplete-select-conta-bancaria-pagamento-field"
                  name="contaBancariaPagamento"
                  label={t('com.muralis.qcx.conta.contaCorrentePagamento')}
                  initialValues={values}
                  disabled={isConsult}
                  fieldProps={{ validate: requiredValidator }}
                  filtraControlaSaldo={SolicitacaoPagamentoUtils.isAdministrativa(values?.tipo)}
                  required
                />
              </Grid>

              {!isMultipla && (
                <>


                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={SolicitacaoPagamentoUtils.isOperacional(values?.tipo) ? 4 : 6}
                  >
                    <QCXFinalTextField
                      id="numero-documento-field"
                      key="numero-documento-field"
                      name="numeroDocumento"
                      label={t('com.muralis.qcx.documento.numeroDocumento')}
                      disabled={isConsult || isContasAPagarView}
                    />
                  </Grid>

                  {SolicitacaoPagamentoUtils.isOperacional(values?.tipo) && (
                    <Grid item xs={12} sm={12} md={2}>
                      <QCXFinalTextField
                        id="numero-nfse-field"
                        key="numero-nfse-field"
                        name="numeroNfse"
                        label="Numero NFSe"
                        disabled={isConsult || isContasAPagarView}
                      />
                    </Grid>
                  )}
                </>
              )}

              {/* ============================= */}
              {/*   CAMPOS GERAIS CONTINUAÇÃO   */}
              {/* ============================= */}


              <Grid item xs={12} sm={12} md={6}>
                <QCXFinalAlternativeCurrencyField
                  id="financeiro-valor-original-field"
                  key="financeiro-valor-original-field"
                  name="valorOriginalMoeda"
                  label="Valor Previsto"
                  disabled={isConsult || isContasAPagarView || isMultipla}
                  onBlur={handleValorMoedaOnBlur(form, values, 'valorOriginalMoeda')}
                  required
                />
              </Grid>


              <Grid item xs={12} sm={6}>
                <QCXFinalTextField
                  id="unidade-pagadora-field"
                  key="unidade-pagadora-field"
                  name="unidadePagadora"
                  label="Unidade pagadora"
                  maxLength="200"
                  disabled={isConsult || isContasAPagarView}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6}>
                <QCXFinalPercentualField
                  id="valor-percentual-desconto-field"
                  key="valor-percentual-desconto-field"
                  name="percentualDesconto"
                  label={t('com.muralis.qcx.percentualDesconto')}
                  scale={5}
                  onBlur={handlePercentualOnBlur(form, values, 'percentualDesconto')}
                  disabled={isConsult || isContasAPagarView || values?.alterarValorAPagar}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6}>
                <QCXFinalAlternativeCurrencyField
                  id="financeiro-valor-desconto-field"
                  key="financeiro-valor-desconto-field"
                  name="valorDescontoMoeda"
                  label={t('com.muralis.qcx.valorDesconto')}
                  onBlur={handleValorMoedaOnBlur(form, values)}
                  disabled={isConsult || isContasAPagarView || values?.alterarValorAPagar}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6}>
                <QCXFinalPercentualField
                  id="valor-percentual-multa-field"
                  key="valor-percentual-multa-field"
                  name="percentualMulta"
                  label={t('com.muralis.qcx.percentualMulta')}
                  scale={5}
                  onBlur={handlePercentualOnBlur(form, values, 'percentualMulta')}
                  disabled={isConsult || isContasAPagarView || values?.alterarValorAPagar}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <QCXFinalAlternativeCurrencyField
                  id="financeiro-valor-multa-field"
                  key="financeiro-valor-multa-field"
                  name="valorMultaMoeda"
                  label={t('com.muralis.qcx.valorMulta')}
                  onBlur={handleValorMoedaOnBlur(form, values)}
                  disabled={isConsult || isContasAPagarView || values?.alterarValorAPagar}
                />
              </Grid>


              <Grid item xs={12} sm={12} md={6}>
                <QCXFinalPercentualField
                  id="valor-percentual-juros-field"
                  key="valor-percentual-juros-field"
                  name="percentualJuros"
                  label={t('com.muralis.qcx.percentualJuros')}
                  scale={5}
                  onBlur={handlePercentualOnBlur(form, values, 'percentualJuros')}
                  disabled={isConsult || isContasAPagarView || values?.alterarValorAPagar}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <QCXFinalAlternativeCurrencyField
                  id="financeiro-valor-juros-field"
                  key="financeiro-valor-juros-field"
                  name="valorJurosMoeda"
                  label={t('com.muralis.qcx.valorJuros')}
                  onBlur={handleValorMoedaOnBlur(form, values)}
                  disabled={isConsult || isContasAPagarView || values?.alterarValorAPagar}
                />
              </Grid>



              <Grid item xs={6} sm={6} md={6}>
                <QCXFinalAlternativeCurrencyField
                  id="financeiro-valor-pagar-field"
                  key="financeiro-valor-pagar-field"
                  name="valorPagarMoeda"
                  label={t('com.muralis.qcx.valorPagar')}
                  onBlur={handleValorMoedaOnBlur(form, values, 'valorPagarMoeda')}
                  disabled={isConsult || isContasAPagarView || !values?.alterarValorAPagar}
                />
              </Grid>

              <Grid item xs={6} sm={6} md={6}>
                <QCXFinalAlternativeCurrencyField
                  id="financeiro-valor-pago-field"
                  key="financeiro-valor-pago-field"
                  name="valorRecebido"
                  label="Valor Pago"
                  onBlur={handleValorMoedaOnBlur(form, values, 'valorRecebido')}
                  disabled
                />
              </Grid>


              {SolicitacaoPagamentoUtils.isAdministrativa(values?.tipo) && (
                <Grid item xs={12} sm={12} md={6}>
                  <QCXFinalNumericIntegerField
                    id="quantidade-parcelas-field"
                    key="quantidade-parcelas-field"
                    name="quantidadeParcelas"
                    label={t('com.muralis.qcx.quantidadeParcelas')}
                    disabled={isConsult || isContasAPagarView || values?.alterarValorAPagar}
                    maxLength={2}
                    allowNegative={false}
                  />
                </Grid>
              )}


              <Grid item xs={12} sm={12} md={6}>
                <QCXFinalPdfInputFile
                  id="upload-input-anexo-documento-para-pagamento"
                  key="upload-input-anexo-documento-para-pagamento"
                  name="documentoPagamento"
                  label={t('com.muralis.qcx.anexarDocumentoPagamento')}
                  tooltipTitle={t('com.muralis.qcx.uploadDocumentoPagamento')}
                  accept={MediaType.APPLICATION_PDF}
                  fileGetter={documentoPagamentoGetter}
                  fileNameGetter={documentoPagamentoNameGetter}
                  disabled={isConsult || isContasAPagarView}
                  multiple
                  filesAsMultipleLines
                />
              </Grid>

              {SolicitacaoPagamentoUtils.isOperacional(values?.tipo) && (
                <>
                  <Grid item xs={12} sm={12} md={6} lg={6}>
                    <QCXFinalCheckboxField
                      id="checkbox-ganho-no-processo"
                      key="checkbox-ganho-no-processo"
                      name="ganhoProcesso"
                      label={t('com.muralis.qcx.ganhoProcesso')}
                      checked={SolicitacaoPagamentoUtils.isGanhoProcesso(isActivate)}
                      onClick={() => onClickProcesso('ganhoProcesso')}
                      disabled={isConsult || isContasAPagarView}
                    />

                    <QCXFinalCheckboxField
                      id="checkbox-perda-no-processo"
                      key="checkbox-perda-no-processo"
                      name="perdaProcesso"
                      label={t('com.muralis.qcx.perdaProcesso')}
                      checked={SolicitacaoPagamentoUtils.isPerdaProcesso(isActivate)}
                      onClick={() => onClickProcesso('perdaProcesso')}
                      disabled={isConsult || isContasAPagarView}
                    />
                  </Grid>

                  {(isActivate || values?.alterarValorAPagar) && (
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <QCXSolicitacaoPagamentoFinanceiroObservacoesGroup
                        disabled={isConsult || isContasAPagarView}
                        form={form}
                        values={values}
                      />
                    </Grid>
                  )}
                </>
              )}

              {isUpdate && (
                <Grid item xs={12} sm={12} md={6}>
                  <QCXFinalCheckboxField
                    id="checkbox-alterar-valor-a-pagar"
                    key="checkbox-alterar-valor-a-pagar"
                    name="alterarValorAPagar"
                    label="Alterar Valor a Pagar"
                    onChange={(event) => form.change('alterarValorAPagar', event.target.checked)}
                    checked={values?.alterarValorAPagar || false}
                  />
                </Grid>
              )}
            </Grid>
          </>
        );
      }}
    </QCXFinalForm>
  );
}